import { Controller } from '../Controller';
import { Helper } from './Helper';
import { AppConfig } from '../../AppConfig';
import { AuthError, ApiDataError, ApiError } from '../errors';

export class ApiHelper {

  static State = Object.freeze({
    LOADING: 1,
    READY: 2,
    ERROR: 3
  });

  static callWithProgressModal(caller, options, callback) {
    caller.refs.apiProgressModal.progress();
    ApiHelper.call(options, function (err, data) {
      if (err) {
        caller.refs.apiProgressModal.error(err);
        return callback(err)
      } else {
        const successMsg = options.successMsg || 'Success'
        caller.refs.apiProgressModal.success(successMsg);
        return callback(err, data)
      }
    })
  }

  static call(options, callback) {
    ApiHelper._fetch(options).then((response) => {
      response.json().then((responseJson) => {
        return callback(null, responseJson)
      }).catch((parseError) => {
        return callback(new ApiDataError())
      });
    }).catch((error) => {
      console.log('error:', error)
      if (error.status === 401) {
        return callback(new AuthError())
      }
      if (!error.json) {
        return callback(new ApiError())
      }
      error.json().then((errorJson) => {
        return callback(errorJson)
      }).catch((parseError) => {
        return callback(new ApiDataError())
      });
    });
  }

  static makeUrlPath(paths, queryParams) {
    let url = AppConfig.ENDPOINT;
    for (const path of paths) {
      url = url + '/' + path;
    }
    if (queryParams) {
      const qs = Helper.encodeQueryString(queryParams);
      if (qs) {
        url += '?' + qs;
      }
    }
    return url;
  }

  static _fetch(options) {
    //console.log('_fetch:', options.method, options.endPoint)
    return new Promise((resolve, reject) => {
      ApiHelper._preAuth(options, function (err) {
        if (err) {
          console.log('Auth Failed');
          reject(err);
        } else {
          const input = {
            method: options.method,
            headers: {}
          };
          if (options.jsonBody) {
            input.body = JSON.stringify(options.jsonBody)
          }
          if (options.authWithKey) {
            input.headers.Authorization = 'Key ' + AppConfig.AppAK;
          } else {
            input.headers.Authorization = 'Bearer ' + Controller.get().userMgr().getUserToken();
          }
          //console.log('fetch:', options.method, options.endPoint, input)
          fetch(options.endPoint, input).then((response) => {
            //console.log('_fetch response:', response);
            if (response.ok) {
              resolve(response);
            } else {
              console.error('_fetch not ok:', response);
              reject(response);
            }
          }).catch((error) => {
            console.error('_fetch error:', error);
            reject(error);
          });
        }
      });
    });
  }

  static _preAuth(options, callback) {
    //console.log('_preAuth');

    if (options.authWithKey) {
      callback(null);
      return;
    }

    const cognitoUser = Controller.get().loginMgr().getCurrentUser()
    if (!cognitoUser) {
      callback('ERROR: User not Logged in!');
      return
    }
    Controller.get().loginMgr().fetchUserToken(cognitoUser, function (err) {
      if (err) {
        console.error(err)
        callback(err);
        return;
      }
      // Token should by now be cached in
      callback(null);
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/helpers/ApiHelper.js